<div class="user-stats__table__row" *ngIf="!isTotalSection">
  <div class="slot slot--format">
    <span class="odilo-icon">{{ formatCell.formatIcon }}</span>
    <div class="slot--format__text">
      <p>{{ formatCell.formatLabel | translate }}</p>
      <p class="slot--format__text__title hide-tablet">{{ dataCells[0].data }}</p>
    </div>
  </div>

  <div class="slot hide-mobile">
    <p>{{ dataCells[0].data }}</p>
  </div>

  <div class="slot" *ngFor="let cell of dataCells | slice: 1; last as isLast" [class.slot--small]="isLast">
    <div class="slot__label hide-tablet">
      <span class="odilo-icon">{{ cell.icon }}</span>
      <p class="slot__label__text">{{ cell.label | translate }}</p>
    </div>
    <p>{{ cell.data }}</p>
  </div>
</div>

<div
  *ngIf="isTotalSection"
  class="user-stats__table__row user-stats__table__row--total"
  [class.user-stats__table__row--last]="isEndRow">
  <div class="slot slot--format">
    <span class="odilo-icon">{{ formatCell.formatIcon }}</span>
    <div class="slot--format__text">
      <p>{{ formatCell.formatLabel | translate }}</p>
      <p class="slot--format__text__title hide-tablet">{{ dataCells[0].data }}</p>
    </div>
  </div>

  <div
    *ngFor="let cell of dataCells; even as isEven; last as isLast"
    class="slot slot--total"
    [class.slot--small]="isLast"
    [class.hide-mobile]="isEven">
    <p>{{ cell.data }}</p>
  </div>
</div>
